import React from "react";
import styles from "./DocumentsManager.module.css";
import AddIcon from "@mui/icons-material/Add";
import SettingsIcon from "@mui/icons-material/Settings";
import Button from "../Button/Button";

interface DocumentsManagerProps {
	onAdd?: () => void;
	onSettings?: () => void;
	children: React.ReactNode;
}

const DocumentsManager = ({ onAdd, onSettings, children }: DocumentsManagerProps) => {
	return (
		<div className={styles.containerDocuments}>
			<div className={styles.headerDocuments}>
				<h2>DOCUMENTOS</h2>

				<div className={styles.headerActions}>
					{onSettings && (
						<Button
							variant="outlined"
							onClick={onSettings}
							title="Configurações"
							className={styles.headerBtn}
						>
							<SettingsIcon />
						</Button>
					)}
					{onAdd && (
						<Button
							variant="outlined"
							onClick={onAdd}
							title="Adicionar"
							className={styles.headerBtn}
						>
							<AddIcon />
						</Button>
					)}
				</div>
			</div>

			<div className={styles.tableWrapper}>
				<div className={styles.customTable}>
						{children}
				</div>
			</div>
		</div>
	);
};

export default DocumentsManager;